<div id=root-element>
    <div id="busy-overlay" class="component-overlay" *ngIf="isBusy">
        <div class="center">
          <mat-spinner color="accent" [diameter]="48"></mat-spinner>
        </div>
    </div>

    <div>
        <button mat-button *ngIf="!hasSubsidySection" color="accent" (click)="initializeSubsidySection()">
            <mat-icon>add</mat-icon>
            FÖRDERPROGRAMM HINZUFÜGEN
        </button>
    </div>

    <div *ngIf="hasSubsidySection">
        <div id="tool-bar">
            <button mat-icon-button *ngIf="isReadonly" color="accent" (click)="deleteSubsidySection()">
                <mat-icon>delete</mat-icon>
            </button>
            <button mat-icon-button *ngIf="isReadonly" color="accent" (click)="startEdit()">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!isReadonly" color="accent" (click)="discardChanges()">
                <mat-icon>clear</mat-icon>
            </button>
            <button mat-icon-button *ngIf="!isReadonly" [disabled]="!hasValidSubsidySection" color="accent" (click)="saveChanges()">
                <mat-icon>done</mat-icon>
            </button>
        </div>
        <div>
            <mat-form-field>
                <mat-label>Förderprogramm</mat-label>
                <input id=test type="text"
                       placeholder="Förderprogramm wählen"
                       matInput
                       [(ngModel)]="subsidyName"
                       [matAutocomplete]="auto"
                       [disabled]="isReadonly">
                <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                    {{option}}
                </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <div style="margin-left: 24px; display: inline-block;">
                <mat-form-field >
                    <mat-label>Zuschuss</mat-label>
                    <input matInput class="funding-amount-input" [disabled]="isReadonly" [(ngModel)]="subsidySection.fundingAmount" type="number" style="-webkit-appearance: none; margin: 0;"/>
                </mat-form-field>
                <label style="margin-left: 4px;">€</label>
            </div>
            <div style="margin-left: 24px; display: inline-block;">
                <mat-checkbox [disabled]="isReadonly" [(ngModel)]="subsidySection.applyOnGross">Auf Bruttobetrag anwenden</mat-checkbox>
            </div>
            
        </div>
        <textarea matInput 
                      [disabled]="isReadonly"
                      [ngModel]="subsidySection.comment" 
                      (ngModelChange)="subsidySection.comment=$event">
        </textarea>
    </div>

</div>
